<template>
    <!--    学位占用查询-->
    <div class="html">
        <div class="body">
            <div id="header">
                <div class="box1">
                    <div class="box2">
                        <p class="Chinese">
                            长春新区招生入学管理平台
                        </p>
                        <p class="English">
                            CHANG CHUN XIN QU ZHAO SHENG RU XUE GUAN LI PING TAI
                        </p>
                    </div>
                </div>
            </div>
            <div class="content">
                <div class="box3">
                    <ul class="ul1">
                        <li><a @click="onjump()"><span>首页</span></a></li>
                        <li><a @click="jump('distRecruitStudents')"><span>招生政策</span></a></li>
                        <li class="special"><span>学位占用查询</span></li>
                        <li><a href="http://www.ccxq.gov.cn/ztzl/xqcx"><span>学区查询</span></a></li>
                        <li id="li" @mouseleave="show=false" @mousemove="show=true">
                            <span>学位预警</span>
                            <ul id="ul2" :class="show==false?'':'dis'">
                                <a @click="jump('distWarningInfo')">
                                    <li>学位预警信息</li>
                                </a>
                                <a @click="jump('waringMap')">
                                    <li>预警地图</li>
                                </a>
                            </ul>
                        </li>
                        <li><a @click="jump('distTransfer')"><span>转学申请</span></a></li>
                        <li><a @click="jump('distGuide')"><span>办事指南</span></a></li>
                    </ul>
                </div>

                <div class="Box">
                    <div :class="code==2?'background1':code==1?'background':''"><!--code==1?'background':-->
                        <div id="box4">
                            <div style="width: 100%;text-align: center;margin-bottom: 30px;">
                                <button :class="span2==true?'span2':''" @click="change1(1)" class="span_special">丘地号查询</button>
                                <button :class="span1==true?'span1':''" @click="change(2)" class="span_special1">房屋地址查询</button>
                            </div>
<!--                            <p>-->
<!--                                <span style="width: 350px;text-align:right;display:inline-block">-->
<!--                                    学校类型：-->
<!--                                </span>-->
<!--                                <el-radio v-model="radio" label="1">小学</el-radio>-->
<!--                                <el-radio v-model="radio" label="2">初中</el-radio>-->
<!--                            </p>-->

                            <p v-show="showx==true">
                                <span style="width: 350px;text-align:right;display:inline-block">小区名称：</span>
                                <!--旧版 start 单纯地输入小区名称或别名-->
                                <!--                                <el-input v-model="input1" placeholder="请输入小区名称或别名" id="input" value="1" ></el-input>&lt;!&ndash;  v-on:input="watchNum()"  &ndash;&gt;-->
                                <!--                                <el-select v-model="input1" placeholder="请选择小区" id="input" :clearable="true">-->
                                <!--                                    <el-option v-for="item in selectVillage" :label="item.name" :value="item.id" :key="item.id"></el-option>-->
                                <!--                                </el-select>-->
                                <!--旧版 end 单纯地输入小区名称或别名-->
                                <el-autocomplete
                                        id="input"
                                        v-model="input1"
                                        :fetch-suggestions="querySearch"
                                        placeholder="请输入小区名称或别名"
                                        :trigger-on-focus="false"
                                        @select="handleSelect">
                                    <template slot-scope="props">
                                        <div class="name">{{ props.item.name }}</div>
                                    </template>
                                </el-autocomplete>
                                <div class="ul_box" v-show="isDisplay">
                                    <div class='search_div' v-for="(item,index) of schdistrictquery" :key="index"
                                         @click="keywordSearch(index,item,1)">
                            <p>{{schdistrictquery.villageName}}</p>
                        </div>
                    </div>
                    <p v-show="showx==true">
                        <span style="width: 350px;text-align:right;display:inline-block">详细地址：</span>
                        <el-input v-model="input2" placeholder="请输入楼栋号" class="input2"></el-input>
                        栋/委
                        <el-input class="input2" v-model="input3" placeholder="请输入单元号"></el-input>
                        单元/组
                        <el-input v-model="input4" class="input2" type="text" placeholder="请输入室号"></el-input>
                        室
                    </p>
                    <p v-show="showq==true" style="height:50px;">
                        <span style="width: 350px;text-align:right;display:inline-block">丘地号：</span>
                        <el-input id="input1" v-model="input5" placeholder="请输入丘地号"></el-input>
                    </p>
                    <p>
                        <span style="width: 350px;text-align:right;display:inline-block">验证码：</span>
                        <el-input class="input2"  v-model="input6" placeholder="请输入验证码" maxlength="4"></el-input>
                        <span class="code" @click="refreshCode" style="position:absolute;top:5px">
                                    <identify class="input2" :identifyCode="identifyCode"> </identify>
                                </span>
                    </p>
                    <span type="primary" @click="search();refreshCode()" class="button">立即查询</span>
                    <div style="width: 100%;text-align: center">
                        <p class="statement">【本查询结果仅供参考，具体以教育行政部门认定为准】</p>
                    </div>
                </div>
                <el-dialog title="查询结果"
                           :visible.sync="dialog.selected"
                           :destroy-on-close="true"
                           :close-on-click-modal="false"
                           @close="handleClose"
                           width="35%">
                    <div class="box5">
                        <!-- 只有房子信息 没有学生信息-->
                        <ul v-if="schdistrictquery.type===2?true:false">
                            <li><span style="width: 150px;margin-left:15%;text-align:right;display:inline-block">小区名称：</span>{{schdistrictquery.villageName}}</li>
                            <li><span style="width: 150px;margin-left:15%;text-align:right;display:inline-block">小区地址：</span>{{schdistrictquery.villageAddress}}</li>
                            <li><span style="width: 150px;margin-left:15%;text-align:right;display:inline-block">楼栋号 ： </span>{{schdistrictquery.houseNo}}</li>
                            <li v-if="type==2&&schdistrictquery.houseAddressNo"><span style="width: 150px;margin-left:15%;text-align:right;display:inline-block">丘地号 ： </span>{{schdistrictquery.houseAddressNo}}</li>
                            <li><span style="width: 150px;margin-left:15%;text-align:right;display:inline-block">所属学校：</span>{{schdistrictquery.schoolName}}</li>
                            <li style="margin-bottom: 12px"><span style="width: 150px;margin-left:15%;text-align:right;display:inline-block">查询时间：</span>{{schdistrictquery.selectTime}}</li>
                        </ul>
                        <!-- 有房子信息 有学生信息-->
                        <ul v-for="(item, index) of this.schdistrictquery.list" :key="index">
                            <!--只有朝阳区有丘地号查询、同时朝阳区不显示小区名称、校区地址、楼栋号-->
                            <p style="width: 100%;margin-left: 80px;text-align: left;font-size: 19px;color: red;" >学生{{index + 1}}：</p>
                            <li><span style="width: 150px;margin-left:15%;text-align:right;display:inline-block">小区名称：</span>{{item.villageName}}</li>
                            <li><span style="width: 150px;margin-left:15%;text-align:right;display:inline-block">小区地址：</span>{{item.villageAddress}}</li>
                            <li><span style="width: 150px;margin-left:15%;text-align:right;display:inline-block">楼栋号 ：</span>{{item.houseNo}}</li>
                            <li v-if="type==2&&item.houseAddressNo"><span style="width: 150px;margin-left:15%;text-align:right;display:inline-block">丘地号 ： </span>{{item.houseAddressNo}}</li>
                            <li><span style="width: 150px;margin-left:15%;text-align:right;display:inline-block">所属学校：</span>{{item.schoolName}}</li>
                            <li><span style="width: 150px;margin-left:15%;text-align:right;display:inline-block">入学时间：</span>{{item.entranceDate}}</li>
                            <li><span style="width: 150px;margin-left:15%;text-align:right;display:inline-block">预计毕业时间：</span>{{item.graduateDate}}</li>
                            <li v-if="(item.temporarySchool===undefined||item.temporarySchool===-1)?false:true">
                                <span style="width: 150px;margin-left:15%;text-align:right;display:inline-block">暂入学校：</span>{{item.temporarySchool}}
                            </li>
                            <li style="margin-bottom: 12px"><span style="width: 150px;margin-left:15%;text-align:right;display:inline-block">查询时间：</span>{{item.selectTime}}</li>
                        </ul>
                        <p class="h44">{{this.schdistrictquery.info}}</p>
                    </div>
                    <div style="width: 100%;text-align: center">
                        <el-button  style="background: rgb(141,192,1);border: 1px solid transparent;color: white;width: 120px;margin-top: -30px" @click="closeDialog()" >确 定</el-button>
                    </div>

                </el-dialog>
                <el-dialog title="阅读查询需知 选择查询方式"
                           :visible.sync="dialog.know"
                           :destroy-on-close="true"
                           :close-on-click-modal="false"
                           @close="handleClose"
                           top="50px"
                           width="40%">
                    <p style="font-size: 18px;padding-left: 30px;padding-right: 30px;margin-bottom: 10px;letter-spacing:1.5px;">一、本系目前统仅适用于查询慧谷学校、慧仁学校、尚德学校、正德学校、英才学校、崇文学校、致远学校、北湖实验、明达学校、启明学校学区内的房产学位占用情况，具体政策按照相关文件规定执行。 </p>
                    <p style="font-size: 18px;padding-left: 30px;padding-right: 30px;margin-bottom: 10px;letter-spacing:1.5px">二、您可以选择以下两种方式中的一种进行查询：</p>
                    <p style="font-size: 18px;padding-left: 30px;padding-right: 30px;margin-bottom: 10px;letter-spacing:1.5px;text-indent:2em">1.丘地号查询
                    </p>
                    <p style="font-size: 18px;padding-left: 30px;padding-right: 30px;margin-bottom: 10px;letter-spacing:1.5px;text-indent:2em">持有房产证或已备案购房合同的，请您务必选择丘地号查询。</p>
                    <p style="font-size: 18px;padding-left: 30px;padding-right: 30px;margin-bottom: 10px;letter-spacing:1.5px;text-indent:2em">2.房屋地址查询 </p>
                    <p style="font-size: 18px;padding-left: 30px;padding-right: 30px;margin-bottom: 10px;letter-spacing:1.5px;text-indent:2em">在房管局无备案，无法提供丘地号，请选择房屋地址查询。 </p>
                    <p style="font-size: 18px;padding-left: 30px;padding-right: 30px;margin-bottom: 10px;letter-spacing:1.5px">三、公办学校实行划片入学（入：即入校报到；学：即学习期间）。学生在片区学校“入读”期间，原则上学校不再接收同一套住房地址的其他适龄儿童少年（符合国家生育政策的除外）入学，即同一套住房小学六年一个学位，初中学校三年一个学位，九年一贯制学校（小学毕业生按照“两个一致”直升本校初中）九年一个学位。学生转出，办理转学手续后可向原学校提出解除学位申请房锁定申请；学生毕业，系统自动解除锁定。</p>
                    <p style="font-size: 18px;padding-left: 30px;padding-right: 30px;margin-bottom: 10px;letter-spacing:1.5px">四、学位申请房查询相关问题，可向小区所属学校咨询。    </p>
                    <p style="font-size: 18px;padding-left: 30px;padding-right: 30px;margin-bottom: 10px;letter-spacing:1.5px;text-indent:2em">学校咨询电话： </p>
                    <p style="font-size: 18px;padding-left: 30px;padding-right: 30px;margin-bottom: 10px;letter-spacing:1.5px;text-indent:2em">慧谷学校：0431-81106565</p>
                    <p style="font-size: 18px;padding-left: 30px;padding-right: 30px;margin-bottom: 10px;letter-spacing:1.5px;text-indent:2em">慧仁学校：0431-82537015</p>
                    <p style="font-size: 18px;padding-left: 30px;padding-right: 30px;margin-bottom: 10px;letter-spacing:1.5px;text-indent:2em">尚德学校、正德学校：0431-82538896</p>
                    <p style="font-size: 18px;padding-left: 30px;padding-right: 30px;margin-bottom: 10px;letter-spacing:1.5px;text-indent:2em">明达学校、启明学校：0431-86236878</p>
                    <p style="font-size: 18px;padding-left: 30px;padding-right: 30px;margin-bottom: 10px;letter-spacing:1.5px;text-indent:2em">英才学校、崇文学校、致远学校、北湖实验学校：0431-86257093</p>
                    <div style="width: 100%;text-align: center">
                        <el-button  style="background: rgb(141,192,1);border: 1px solid transparent;color: white;width: 120px;margin-top: 40px" @click="closeKnowDialog()" >确 定</el-button>
                    </div>
                </el-dialog>
            </div>
            <div class="box6">
                <div class="explain">
                    <h3>查询说明：</h3>
                    <div v-html="content" class="details"></div>
                </div>
            </div>
        </div>
    </div>
    </div>
    <div class="interlayer"></div>
    <foot></foot>
    </div>

</template>
<script>
    import {districts, action, content, stuposition, selectVillage} from "@/modules/district/api";
    import identify from "@/components/identify.vue";
    import 'element-ui/lib/theme-chalk/index.css'
import foot from "@/components/foot.vue";
    export default {
        name: "degree",
        components: {
             foot,
            identify
        },
        data() {
            return {
                newYear:new Date().getFullYear(),
                dialog:{
                    selected:false,
                    know:false
                },
                isHaveVillage: false,
                villageId: '',
                selectVillage: [],
                restaurants: [],
                radio: '1',
                districts: [],
                input1: '',
                input2: '',
                input3: '',
                input4: '',
                input5: '',
                input6: '',
                arr: [],
                action: [],
                content: '',
                showx: false,
                showq: true,
                span1: false,
                span2: true,
                type: 2, //1 房屋地址查询 2丘地号查询
                code: 2,
                showcheckeddetailelement: false,
                show: false,
                schdistrictquery: {},
                districtName: {
                    cityAreaDynamic: "县区动态",
                    cityRecruitStudents: "招生政策",
                    cityWarningInfo: "招生预警信息",
                    distDegree: "学位占用查询",
                    distGuide: "办事指南",
                    distRecruitStudents: "招生政策",
                    distSchDistrict: "学区查询",
                    distTransfer: "转学申请",
                    distWarningInfo: "招生预警信息"

                },
                identifyCode: '',
                // identifyCodes: '1234567890abcdefjhijklinopqrsduvwxyz',
                identifyCodes: '123456789abcdefjhijkmnpqrstuvwxyz',
                isDisplay: false
            }
        },
        computed: {
            name() {
                return this.$site.getName();
            },

            orgId() {
                return this.$site.getOrg();
            }

        },

        created() {
            this.loadBaseData();
            // 初始化验证码
            this.identifyCode = ''
            this.makeCode(this.identifyCodes, 4)
            this.dialog.know  = true
        },
        mounted() {
            // this.restaurants = this.loadAll();
        },
        methods: {
            async loadBaseData() {
                let res = await districts()
                this.districts = res.data
                for (let i = 0; i < this.districts.length; i++) {
                    let item = this.districts[i]
                    if (item.org_id != this.orgId) {
                        this.arr.push(item)
                    }

                }
                res = await action({orgId: this.orgId, templateId: 1})
                this.action = res.data
                res = await content({orgId: this.orgId, templateId: 1, key: 'houseAddressNo'})
                this.content = res.data
                res = await selectVillage({districtId: 220177})
                this.restaurants = res.data
            },
            onjump() {
                window.location.href = "/#/"
            },
            jump(item) {
                if (item == "distSchDistrict") {
                    window.location.href = "http://ccxq.gov.cn/xueqvchaxun.aspx"
                } else {
                    this.$router.push(item)
                }
            },
            transname(orgId, name) {
                this.$site.setOrg(orgId)
                this.$site.setName(name)

                let path = this.$route.path
                if (path == "/distDegree") {
                    this.$router.go(0)
                } else {
                    this.$router.push("distDegree")
                }
            },
            async change() {
                if (this.type && this.type == 2) { // 切换tab初始化数据
                    // this.radio='1'
                    this.input1 = ''
                    this.input2 = ''
                    this.input3 = ''
                    this.input4 = ''
                    this.input6 = ''
                    const res = await content({orgId: this.orgId, templateId: 1, key: 'degree'})
                    this.content = res.data
                }
                this.showx = true;
                this.showq = false;
                this.span1 = true;
                this.span2 = false;
                this.type = 1;
                this.schdistrictquery = {};
                this.code = 2
            },
           async change1() {
                if (this.type&&this.type==1){ // 切换tab初始化数据
                    // this.radio='1'
                    this.input5=''
                    this.input6=''
                    const res = await content({orgId: this.orgId, templateId: 1, key: 'houseAddressNo'})
                    this.content = res.data
                }
                this.showx = false;
                this.showq = true;
                this.span1 = false;
                this.span2 = true;
                this.type = 2;
                this.schdistrictquery = {};
                this.code = 2
            },
            /** 图形验证码*/
            randomNum(min, max) {
                return Math.floor(Math.random() * (max - min) + min)
            },
            refreshCode() {
                this.identifyCode = ''
                this.makeCode(this.identifyCodes, 4)
            },
            makeCode(o, l) {
                for (let i = 0; i < l; i++) {
                    this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)]
                }
            },
            querySearch(queryString, cb) {
                var restaurants = this.restaurants;
                var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                // 调用 callback 返回建议列表的数据
                if (results.length == 0) { // 未匹配到数据
                    this.isHaveVillage = false
                    alert("系统中不在该小区，请重新核对小区名称。")
                } else {
                    this.isHaveVillage = true
                }
                cb(results);
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            handleSelect(item) {
                this.input1 = item.name
                this.villageId = item.id
            },
            search() {
                this.dialog.selected = true
                if (this.input6 != this.identifyCode) {
                    this.schdistrictquery.list = {}
                    this.schdistrictquery.info = "输入验证码错误，请重试！"
                    return false
                }



                if (this.type == 1) {
                    if (!this.isHaveVillage){
                        this.schdistrictquery.info ="系统中不在该小区，请重新核对小区名称！"
                        return false
                    }
                    stuposition({
                        orgId: this.orgId,
                        // schoolType: this.radio,
                        type: this.type,
                        villageId: this.villageId,
                        tungNo: this.input2,
                        unitNo: this.input3,
                        houseNo: this.input4
                    }).then((res) => {
                        if (res.code == '0') {
                            if (res.data == null) {
                                alert(res.message)
                            }
                            if (res.data.type == 1) {
                                this.code = 1
                            } else {
                                this.code = res.code
                            }

                            this.schdistrictquery = res.data
                        } else {
                            this.code = res.code
                            alert(res.message);
                        }
                    })
                } else {
                    stuposition({
                        orgId: this.orgId,
                        // schoolType: this.radio,
                        type: this.type,
                        houseAddressNo: this.input5
                    }).then((res) => {
                        if (res.code == '0') {
                            if (res.data == null) {
                                alert(res.message)
                            }
                            if (res.data.type == 1) {
                                this.code = 1

                            } else {
                                this.code = res.code
                            }
                            this.schdistrictquery = res.data
                        } else {
                            this.code = res.code
                            alert(res.message);
                        }
                    })
                }
            },
            handleClose(){
                Object.assign(this.$options.data())
            },
            closeDialog(){
                this.dialog.selected = false
            },
            closeKnowDialog(){
                this.dialog.know = false
            }
            // async watchNum(){
            //     let res = await watchNum({key: this.keyword});
            //     if(res.code !==0) {
            //         this.display=true
            //         this.schdistrictquery = res.data.info;
            //     }
            //     this.realnum=Number(this.input1-this.fee).toFixed(2)
            // }
        }
    }

</script>
<style>
    * {
        margin: 0;
        padding: 0;
        list-style: none;
        text-decoration: none;
    }

    .html {
        width: 100%;
        height: auto;
        min-height: 100%;
        position: relative;
        overflow-x: hidden;
        overflow: hidden;
    }

    .body {
        width: 100%;
        height: auto;
        position: relative;
    }

    #header {
        width: 100%;
        height: 239px;
        background: url("../../../assets/eduDefault/bg.png") no-repeat;
        background-size: cover;
        position: relative;
    }

    .box1 {
        width: 668.16px;
        height: 84.96px;
        position: absolute;
        top: 60px;
        cursor: pointer;
    }

    .box2 {
        width: 583.2px;
        height: auto;
        position: absolute;
        right: 0;
        top: 0;
    }

    .Chinese {
        font-family: PingFangSC-Semibold;
        font-size: 43.2px;
        color: #3D3D3D;
        letter-spacing: 2px;
        font-weight: bold;
    }

    .English {
        font-family: PingFang-SC-Semibold;
        font-size: 14px;
        color: #494949;
        letter-spacing: 2px;
        line-height: 36px;
    }


    .box3 {
        width: 100%;
        height: auto;
        background: #FFFFFF;
        box-shadow: 0 9px 10px 5px rgba(224, 224, 224, 0.50);
    }

    .box3 .ul1 {
        width: 1148px;
        height: 54px;
        margin: 0 auto;
    }

    .box3 .ul1 li {
        width: 164px;
        height: 100%;
        line-height: 54px;
        float: left;
        text-align: center;
        cursor: pointer;
        font-size: 15.6px;
        font-family: PingFangSC-Regular;
        color: #000000;
        letter-spacing: -0.66px;
    }

    .box3 .ul1 li a {
        color: #000;
        display: block;
    }

    .box3 .ul1 li:hover a {
        color: #fff;
    }

    .box3 .ul1 li:hover {
        background: #ABE000;
        color: #fff;
    }

    .box3 .ul1 .special {
        background: #ABE000;
        color: #fff;
    }


    #ul2 {
        display: none;
    }

    #ul2 a li {
        background: #fff;
        box-shadow: 0 9px 10px 5px rgba(224, 224, 224, 0.50);
    }

    #ul2 a:hover li {
        background: #ABE000;
        color: #fff;
    }

    .Box {
        width: 1150px;
        height: auto;
        position: relative;
        padding-bottom: 60px;
        margin: 30px auto;
        margin-top: 120px;
        /*z-index:-1;*/
    }

    .Box .background {
        /*margin-left: 10%;*/
        width: 100%;
        height: auto;
        background-position-x: 870px;
        background-position-y: 50%;
    }

    .Box .background1 {
        width: 100%;
        height: auto;
        /*background: url("../../../assets/eduDefault/bg_have.png") no-repeat;*/
        background-position-x: 870px;
        background-position-y: 50%;
    }

    .Box #box4 {
        width: 100%;
        height: auto;
        /*border-right: 1px solid #ccc;*/
        padding-bottom: 30px;
        padding-top: 0px;
    }

    .el-dialog__headerbtn .el-dialog__close {
        color: white;
    }

    .el-dialog__header {
        padding: 20px 20px 10px;
        background-color: rgb(141,192,1);
        text-align: center;
    }
    .el-dialog__title {
        line-height: 24px;
        font-size: 20px;
        color: white;
    }
    .h2 {
        height: 100px;
        line-height: 100px;
        margin-top: 40px;
        margin-bottom: 20px;
        border-bottom: 1px solid #ccc;
        text-indent: 1em;
        letter-spacing: 0.14px;
    }

    .h2 a {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #30302F;
        letter-spacing: 0.14px;
        text-decoration: underline;
        margin-right: 30px;
        cursor: pointer;
    }

    .h2 a:hover {
        color: #FE8E00;
    }

    #box4 .span_special {
        width: 17%;
        height: 40px;
        color: white;
        cursor: pointer;
        letter-spacing: 0.34px;
        border-radius: 3px;
        background-color: rgb(214,214,214);
        font-size: 15px;
        border: none;
        outline: none;
    }
  #box4 .span_special1 {
        width: 17%;
        height: 40px;
        color: white;
        cursor: pointer;
        letter-spacing: 0.34px;
        border-radius: 3px;
        background-color: rgb(214,214,214);
        font-size: 15px;
        border: none;
        outline: none;
    }

    #box4 .span1 {
        width: 17%;
        height: 40px;
        line-height: 40px;
        font-weight: bold;
        margin-left: 50px;
        /*border-bottom: 1px solid #8DC001;*/
        background-color: rgb(141,192,1);
        letter-spacing: 0.34px;
        border-radius: 3px;
        color: white;
        font-size: 15px;
        border: none;
        outline: none;
    }

    #box4 .span2 {
        width: 17%;
        height: 40px;
        line-height: 40px;
        font-weight: bold;
        margin-right: 50px;
        /*border-bottom: 1px solid #8DC001;*/
        background-color: rgb(141,192,1);
        color: white;
        border-radius: 3px;
        letter-spacing: 0.34px;
        font-size: 15px;
        border: none;
        outline: none;
    }
    .el-radio__inner{
        margin-left: 20px;
    }
    .el-radio__input.is-checked .el-radio__inner {
        border-color: rgb(141,192,1);
        background: rgb(141,192,1);
    }

    .el-radio__input.is-checked+.el-radio__label {
        color: black;
    }

    #box4 p {
        line-height: 50px;
        position: relative;
    }

    #box4 input {
        margin-left: 10px;
        margin-right: 10px;
        color: #000;
        letter-spacing: 0.24px;
        font-size: 15px;
    }

    #input {
        width: 300px;
        height: 30px;
        position: absolute;
        left: 10px;
        top: -20px;
        border: 1px solid #979797;
        border-radius: 2px;
        outline: medium;
    }

    .el-input__inner {
        padding: 0px 8px;
    }

    .el-input__suffix {
        right: -320px;
    }

    .el-input__suffix-inner {
        position: relative;
        top: -30px;
    }

    .el-input__icon {
        height: auto;
    }

    #input1 {
        width: 300px;
        height: 30px;
        position: absolute;
        left: 360px;
        top: -70px;
        border: 1px solid #979797;
        border-radius: 2px;
        outline: medium;
    }

    #box4 .input2 {
        display: inline;
        margin-left: 10px;
    }


    #box4 .input2 input {
        width: 110px;
        height: 30px;
        border: 1px solid #979797;
        border-radius: 2px;
        outline: medium;
    }

    #box4 .button {
        display: block;
        width: 123px;
        height: 43px;
        background-size: cover;
        position: relative;
        top: 50px;
        left: 50%;
        margin-left: -62px;
        color: #fff;
        cursor: pointer;
        background: #8DC001;
        border-radius: 10px;
        text-align: center;
        line-height: 43px;
        letter-spacing: 1px;
    }

    #box4 .statement {
        position: relative;
        top: 80px;
        /*left: 350px;*/
        color: #FF2525;
    }

    .box5 {
        font-size: 17px;
        text-align: left;
        min-height: 130px
    }

    .h44 {
        width: 100%;
        font-size: 30px;
        color: #FF2525;
        letter-spacing: 0.24px;
        text-align: center;
        margin-top: 35px;
        margin-bottom: 40px;
        font-weight: normal;
    }

    .box5 ul{
        margin-bottom: 20px;
    }
    .box5 ul li {
        line-height: 34px;
    }

    .box6 {
        width: 100%;
        height: auto;
        position: relative;
        margin-top: 100px;
    }

    .explain {
        width: 90%;
        height: auto;
        margin: 0 auto;
    }

    .explain h3 {
        color: #30302F;
        letter-spacing: 0.34px;
        line-height: 60px;
    }

    .explain .details {
        width: 100%;
        height: auto;
        line-height: 40px;
        font-size: 14px;
        margin-top: 15px;
        color: #30302F;
        letter-spacing: 0.24px;
    }

    .interlayer {
        width: 100%;
        height: 10px;
        background: #ABE000;
    }

    #footer {
        width: 100%;
        height: auto;
        background-image: linear-gradient(180deg, #2A76E6 0%, #5AB6FF 100%);
    }


    .link .ul4 a {
        color: #fff;
        font-size: 16px;
        text-decoration: none;
        line-height: 42px;
    }

    #footer .footer-bottom {
        width: 100%;
        height: 108.8px;
        background: #fff;
    }

    #footer .footer-bottom .box7 {
        color: #5f6464;
        font-size: 16px;
        position: relative;
        top: 24.4px;
        letter-spacing: 0.5px;
    }

    #footer .footer-bottom .box7 p {
        line-height: 30px;
        text-align: center;
    }

    #footer .footer-bottom .box7 p:nth-child(3) {
        margin-left: -9px;
    }

    #footer .footer-bottom .box7 img {
        width: 20px;
        height: 20px;
        position: relative;
        left: 0px;
        top: 3px;
        margin-right: 5px;
    }

    .dis {
        display: block !important
    }

</style>
